<template>
    <client-page>

        <sub-visual
        sh="Distributor in Korea"
        tabActive="TDK Power Supply"
        bg="/images/sub/visual/sv3.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    TDK Power Supply
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/distributor/tdk/tdk-top-img.png"
            className="h-lg-380px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    전원의 트랜스에 사용되는 중요한 구성부품을 <br>
                    그룹 내의 제품으로 제조하고 있는 <br>
                    유일한 전원 메이커입니다. 
                </h3>
                <p class="page-text color-grey-51 mb-12 mb-lg-30">
                    전원의 트랜스에 사용되는 페 라이트, 인덕터, 콘덴서 등의 중요한 <br class="d-none d-md-block">
                    구성부품을 그룹 내의 제품으로 제조하고 있는유일한 전원 메이커입니다. <br>
                    따라서 이러한 소재나 부품 레벨 등으로 전원제품의 개발이 가능하며 <br class="d-none d-md-block">
                    지금까지의 회로설계기술, 열・전자계 평가・시뮬레이션 기술 등의 <br class="d-none d-md-block">
                    코어 테크놀로지를 활용한 혁신적인 전원을 개발하고 있습니다.
                </p>
                <p class="color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    취급제품 (TDK-Lambda Brand)
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51">
                    AC입력전원（AC-DC컨버터）, DC입력전원（DC-DC컨버터), 직류안정화전원 (CVCC), <br class="d-none d-md-block">
                    쌍방향 컨버터, 전자부하, 전원 라인용 EMC 필터, 산업기기향의 wireless 급전 시스템
                </p>
            </sub-bg-image>

        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout
                tit="TDK Power Supply"
                className="full">

                    <v-row class="my-n10 my-lg-n30">
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="AC 입력전원 (AC-DC 컨버터)"
                            src="/images/sub/distributor/tdk/tdk-img3-1.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="DC 입력전원 (DC-DC 컨버터)"
                            src="/images/sub/distributor/tdk/tdk-img3-2.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="직류 안정화 전원 (CVCC)"
                            src="/images/sub/distributor/tdk/tdk-img3-3.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="고압전원"
                            src="/images/sub/distributor/tdk/tdk-img3-4.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="양방향 컨버터"
                            src="/images/sub/distributor/tdk/tdk-img3-5.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="전자부하"
                            src="/images/sub/distributor/tdk/tdk-img3-6.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="전원 라인용 EMC Filter"
                            src="/images/sub/distributor/tdk/tdk-img3-7.png">
                            </image-detail>
                        </v-col>
                        <v-col cols="6" md="4" class="py-10 py-lg-30">
                            <image-detail
                            tit="악세사리 (전원제품용)"
                            src="/images/sub/distributor/tdk/tdk-img3-8.png">
                            </image-detail>
                        </v-col>
                    </v-row>

                </sub-line-layout>
            </v-container>
        </section>

        <div class="sub-section sub-section--last">
            <v-container>

                <inquiry
                src="/images/sub/distributor/tdk/tdk-img1.png"
                name="황 정호"
                tel="031-765-2268"
                mail="hwangjoe@ist-co.kr"
                fax="031-765-2389"
                link="https://www.jp.lambda.tdk.com/ko/index.html"
                linkBg="/images/sub/distributor/tdk/tdk-img2.png">
                </inquiry>

            </v-container>
        </div>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/ko/sub/sub-bg-image.vue";
import Inquiry from "@/components/client/ko/sub/sub-inquiry.vue";
import ImageDetail from "@/components/client/ko/sub/sub-image-detail.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        Inquiry,
        ImageDetail,
    },
};
</script>

<style lang="scss" scoped>
</style>